import React, { forwardRef, useEffect } from "react";
import { useLocation, useNavigate, useParams, useMatch, useSearchParams, Location, NavigateFunction, Params, PathMatch } from "react-router-dom";
import { useStorage } from "../@main-module/storage-manager";

type IWithHocProps = {
  location: Location;
  navigate: NavigateFunction;
  params: Readonly<Params<string>>;
  match: PathMatch<string> | null;
  searchParams: URLSearchParams;
  setStorage: (key: string, data: any) => void;
  getStorage: (key: string) => any;
};

type ConfigOptions = {
  isAuthPage?: boolean;
  isRestriected?: boolean;
};

export function hocHook<P extends IWithHocProps>(Component: React.ComponentType<P>, conf: ConfigOptions = { isAuthPage: false, isRestriected: false }) {
  const RouteForward = forwardRef<unknown, Omit<P, keyof IWithHocProps>>((props, ref) => {
    useEffect(() => {
      window.scrollTo({ top: 0 });
    }, []);
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const match = useMatch(location.pathname);
    const [searchParams] = useSearchParams();
    const storageActions = useStorage();

    return <Component {...(props as any)} ref={ref} {...storageActions} location={location} navigate={navigate} params={params} match={match} searchParams={searchParams} />;
  });

  RouteForward.displayName = `withRouter(${Component.displayName || Component.name || "Component"})`;

  return RouteForward;
}
